import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import FilingForm from "../../../common/form/filing/FilingForm";

const SEVerLetterStepFiling = () => {
  const seVerLetterForm = useAppSelector((state) => {
    return state.Forms.SEVerLetterForm;
  });

  return (
    <FilingForm
      basePath={baseEndpointPaths.seRecognition}
      appId={seVerLetterForm.id}
      redirectPath={"/se-application"}
      allowedFileApplicationAction={false}
    />
  );
};
export default SEVerLetterStepFiling;
